import { AssetDTO } from "./asset-dto";
import { Offer } from "./catalog-dto";

export class Asset {

    public ID: string;
    public name: string;
    public contentType: string;
    public version: string;
    public baseUrl: string;
    public originalDTO: AssetDTO;
    public distribution: string[];
    public connector?: string;
    public originator?: string;

    constructor(
        ID: string,
        name: string,
        contentType: string,
        version: string,
        baseUrl: string,
        originalDTO: AssetDTO,
        distribution: string[]
    ) {
        this.ID = ID;
        this.name = name;
        this.contentType = contentType;
        this.version = version;
        this.baseUrl = baseUrl;
        this.originalDTO = originalDTO;
        this.distribution = distribution;
    }

    private static getProperty(
        properties: Record<string, unknown>,
        key: string,
        defaultValue = ''
    ): string {
        const v = properties[key];
        if (v === undefined || v === null) {
            return defaultValue;
        }
        if (typeof v === 'string') {
            return v;
        }
        if (typeof v === 'number' || typeof v === 'boolean') {
            return String(v);
        }
        return defaultValue;
    }

    public static createFromDTO(dto: AssetDTO): Asset {
        const props = dto.properties;
        return new Asset(
            dto["@id"],
            Asset.getProperty(props, 'name'),
            Asset.getProperty(props, 'contenttype'),
            Asset.getProperty(props, 'version'),
            dto.dataAddress.baseUrl,
            dto,
            dto.distribution
        );
    }
}

export interface AssetWithOffers extends Asset {
    offers: Offer[];
}